import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { NewActivity } from 'types';
import { PicInPicAds } from 'types/interfaces/ads/PicInPicAds';
import { UserCard } from 'types/interfaces/user/UserCard';

import { FinderFilters } from 'api/FinderApi';

interface FinderUserVideo {
  videoId: number;
  videoUrl: string;
  userId: number;
  label?: string;
}

type FinderState = {
  users: UserCard[];
  filters: FinderFilters | null;
  next: string | null;
  currentPage: number;
  currentProfilesPackHash: string;
  sympathies: NewActivity | null;
  loading: boolean;
  initLoading: boolean;
  video: null | FinderUserVideo;
  adsVideo: null | (PicInPicAds & { requestTs: number });
};

const initialState: FinderState = {
  users: [],
  filters: null,
  next: null,
  currentPage: 1,
  currentProfilesPackHash: '',
  sympathies: null,
  loading: false,
  initLoading: false,
  video: null,
  adsVideo: null,
};

const finderSlice = createSlice({
  name: 'finder',
  initialState,
  reducers: {
    addUsers(state, action: PayloadAction<UserCard[]>) {
      state.users = [...state.users, ...action.payload];
    },
    setUsers(state, action: PayloadAction<UserCard[]>) {
      state.users = action.payload;
    },
    likeUser(state, action: PayloadAction<number>) {
      const { payload: userId } = action;

      state.users = state.users.map((user) =>
        user.id === userId ? { ...user, liked: true } : user
      );
    },
    setFilters(state, action: PayloadAction<FinderFilters | null>) {
      state.filters = action.payload;
    },
    setNext(state, action: PayloadAction<string | null>) {
      state.next = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setInitLoading(state, action: PayloadAction<boolean>) {
      state.initLoading = action.payload;
    },
    setCurrentpage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload;
    },
    setCurrentProfilesPackHash(state, action: PayloadAction<string>) {
      state.currentProfilesPackHash = action.payload;
    },
    setSympathies(state, action: PayloadAction<NewActivity>) {
      state.sympathies = action.payload;
    },
    setFinderUserVideo(state, action: PayloadAction<null | FinderUserVideo>) {
      state.video = action.payload;
    },
    setFinderAdsVideo(
      state,
      action: PayloadAction<null | (PicInPicAds & { requestTs: number })>
    ) {
      state.adsVideo = action.payload;
    },
  },
});

export const {
  addUsers,
  setUsers,
  likeUser,
  setFilters,
  setNext,
  setLoading,
  setInitLoading,
  setCurrentpage,
  setCurrentProfilesPackHash,
  setSympathies,
  setFinderUserVideo,
  setFinderAdsVideo,
} = finderSlice.actions;

export const finder = finderSlice.reducer;
